import { email, helpers, required, url } from 'vuelidate/lib/validators'

export const phoneAndEmailCheck = (v = '') => {
  const regex =
    /^(\s*(?:\+?(\d{1,3}))?([-. (]*(\d{1,3})[-. )]*)?((\d{1,4})[-. ]*(\d{0,4})[-. ]*(\d{0,4})[-. ]*(\d{0,7}))|\w[\w\-.]+@\w+\.\w{2,3})$/m
  if (!v) return false
  return !!v.match(regex)
}
export const phoneOrEmailCheck = val =>
  helpers.regex(
    'phoneOrEmailCheck',
    /^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{1,3})[-. )]*)?((\d{1,4})[-. ]*(\d{0,4})[-. ]*(\d{0,4})[-. ]*(\d{0,7}))$/m
  )(val) || email(val)

export const phoneValidator = val =>
  helpers.regex('phoneCheck', /^\+7\s\(\d{3}\)\s\d{3}-\d{2}-\d{2}$/gm)(val)

export const alphaLatinValidator = (v = '') => {
  const regex = /[a-z]|-/gi
  if (!v) return false
  return Array.from(v.matchAll(regex), m => m[0]).length === v.length
}

export const slugValidator = (v = '') => {
  const regex = /^\/|[a-z0-9]+(?:[_-][a-z0-9]+)*$/
  if (!v) return false
  return !!v.match(regex)
}

export const slugAsyncValidator = async (value, id, query, ctx, entity) => {
  if (value === '') {
    return true
  }
  if (ctx?.$apollo?.query) {
    const { data } = await ctx?.$apollo
      ?.query({
        query,
        fetchPolicy: 'no-cache',
        variables: {
          where: {
            slug: value,
            id_not: +id
          }
        }
      })
      .catch(err => console.log(err))

    if (data[entity].list.length) {
      return false
    } else {
      return true
    }
  }
  return true
}

export const unitsValidator = (value = '') => {
  if (!value) return false
  const stringedValue = String(value).trim()
  const regex = /^(\d\.?\d+)(px|em|%|in|pt+)$/gim
  return stringedValue.match(regex) !== null
}

export const numericValidator = (value = '') => {
  if (!value) return false
  const stringedValue = String(value).trim()
  const regex = /^[0-9]*\.?[0-9]*$/gim
  return stringedValue.match(regex) !== null
}

export const timeValidator = (value = '') => {
  if (!value) return false
  const stringedValue = String(value).trim()
  const regex = /^([0-1]?[0-9]|[2][0-3]):([0-5][0-9]):?([0-5][0-9])?$/gm
  return stringedValue.match(regex) !== null
}

export const customValidators = {
  unitsValidator,
  numericValidator,
  youtubeVimeoVkRutube: value => {
    const regex = /youtube.com|vimeo.com|vk.com|rutube.ru/g
    return value.match(regex) !== null
  }
}

export const addressValidator = (address = null) => {
  if (!address) return false
  return address.address !== ''
}

export const validationErrorMessages = {
  required: 'Oбязательное поле',
  maxLength: 'Превышена допустимая длинна поля',
  unique: 'Значение поля должно быть уникальным, выберите другое значение',
  slugGeneralMsg:
    'Уникальное имя slug может состоять только из цифр, латинских букв и символов тире'
}

export const validationsTypes = {
  url,
  required,
  alphaLatinValidator,
  slugValidator,
  unitsValidator
}
